import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";

const initialState = {
  loading: false,
  error: null,
  emailTemplates: {
    templates: [],
    currentPage: 1,
    hasMore: true,
  },
  assignData: {
    data: [],
    followData: [],
  },
  shuffle: {
    data: [],
    history: [],
  },
  instantly: {
    campaigns: {
      data: [],
      nextpage: null,
    },
    createCampaigns: {},
    accessId:null,
  },
};

const campaignsSlice = createSlice({
  name: "campaigns",

  initialState,
  reducers: {
    getTemplatesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTemplatesSuccess(state, action) {
      state.loading = false;
      state.emailTemplates.templates = action.payload.data;
    },
    getTemplatesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    appendTemplates(state, action) {
      state.loading = false;
      state.emailTemplates.templates = [
        ...state.emailTemplates.templates,
        ...action.payload.data,
      ];
    },
    clearTemplates(state) {
      state.emailTemplates.templates = [];
      state.emailTemplates.currentPage = 1;
      state.emailTemplates.hasMore = true;
      state.loading = false;
      state.error = null;
    },
    removeTemplate(state, action) {
      state.emailTemplates.templates = state.emailTemplates.templates.filter(
        (t) => t.uiid !== action.payload
      );
    },
    //assign data
    getAssignDataStart(state) {
      state.loading = true;
      state.error = null;
    },
    getAssignDataSuccess(state, action) {
      state.loading = false;
      state.assignData.data = action.payload.data; // your API response data
    },
    getAssignDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearAssignData(state) {
      state.assignData.data = [];
      state.loading = false;
      state.error = null;
    },
    // follow up assign data
    // getFollowAssignDataStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // getFollowAssignDataSuccess(state, action) {
    //   state.loading = false;
    //   state.assignData.followData = action.payload.data; // FollowUpAssign data
    // },
    //save shuffle
    saveShuffleStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveShuffleSuccess(state, action) {
      state.loading = false;

      // replace current data with latest API response
      state.shuffle.data = action.payload.data;

      // keep a log of all saved shuffles in the session
      state.shuffle.history.push(action.payload.data);
    },
    saveShuffleFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearShuffle(state) {
      state.shuffle.data = [];
      state.shuffle.history = [];
      state.loading = false;
      state.error = null;
    },
    // in your campaignsSlice
    getFollowAssignDataStart(state) {
      state.loading = true;
      state.error = null;
    },
    getFollowAssignDataSuccess(state, action) {
      state.loading = false;
      state.assignData.followData = action.payload.data;
    },
    getFollowAssignDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearFollowAssignData(state) {
      state.assignData.followData = [];
      state.loading = false;
      state.error = null;
    },
    getInstantlyCampaign(state, action) {
      state.loading = true;
    },
    successInstantlyCampaign(state, action) {
      state.loading = false;
      state.instantly.campaigns = {
        ...action.payload,
      };
    },
    sendBulkEmailsStart(state,action){
      state.loading = true;
      state.error = null;
    },
    successSendBulkEmailsStart(state,action){
     state.loading = false;
    },
    failureSendBulkEmailsStart(state,action){
     state.loading=false;
     state.error=action.payload
    },
    createInstantlyCampaign(state, action) {
      state.loading = true;
    },
    successCreateInstantlyCampaign(state, action) {
      state.loading = false,
      state.instantly.createCampaigns = {
        ...state.instantly.createCampaigns,
          ...action.payload,
        };
    },
    getInstantlyAccessId(state,action){
      state.loading=true;
    },
    successGetInstantlyAccessId(state,action){
      state.instantly.accessId=action.payload;
      state.loading=false;
    }
  },
});

export const {
  getTemplatesStart,
  getTemplatesSuccess,
  getTemplatesFailure,
  appendTemplates,
  clearTemplates,
  removeTemplate,
  getAssignDataStart,
  getAssignDataSuccess,
  getAssignDataFailure,
  clearAssignData,
  getFollowAssignDataStart,
  getFollowAssignDataSuccess,
  getFollowAssignDataFailure,
  saveShuffleStart,
  saveShuffleSuccess,
  saveShuffleFailure,
  clearShuffle,
  successInstantlyCampaign,
  getInstantlyCampaign,
  createInstantlyCampaign,
  successCreateInstantlyCampaign,
  sendBulkEmailsStart,
  successSendBulkEmailsStart,
  failureSendBulkEmailsStart,
  clearFollowAssignData,
  getInstantlyAccessId,
  successGetInstantlyAccessId,
} = campaignsSlice.actions;

export default campaignsSlice.reducer;
